import angular from 'angular';
import d3 from 'd3';
import { wrapLabels } from './hvr-chart-helpers';
import { isNil } from 'lodash';

import {} from './od-hvr-charts.less';

module.exports = angular.module('market.components.od-hvr-bar-chart', [])
.component('odHvrBarChart', {
  bindings: {
    data: '<',
  },
  controller: class {
    constructor($element, $mediaQuery) {
      this.$element = $element;

      this.elemWidth = 425;
      this.elemHeight = 325;
      if (!$mediaQuery('gt-xs')) {
        this.elemWidth = 300;
        this.elemHeight = 250;
      }

      $element.append(`
        <svg
          width="${this.elemWidth}"
          height="${this.elemHeight}"
          viewbox="0 0 ${this.elemWidth} ${this.elemHeight}"
          preserveaspectratio="xMidYMid meet"
        >
        </svg>
      `);

      this.buildChart($element.find('svg'));
    }

    buildChart(chartElement) {
      if (isNil(this.data)) {
        return;
      }
      let data = this.data;

      let iconUrl = 'https://images.opendoor.com/source/s3/imgdrop-production/hvr-label-your-home.svg?service=web';
      let iconWidth = 99;
      let iconHeight = 33;
      let iconMarginTop = 10;

      let svg_elem = d3.select(chartElement[0]);
      let margin = { top: 60, right: 20, bottom: 60, left: 40 };
      let width = this.elemWidth - margin.left - margin.right;
      let height = this.elemHeight - margin.top - margin.bottom;

      // spacing between bars: 0.5 (almost none) to 1.0 (so much spacing, can't even see the bars!)
      let x = d3.scale.ordinal().rangeRoundBands([0, width], .40);
      let y = d3.scale.linear().range([height, 0]);

      let xAxis = d3.svg.axis()
        .scale(x)
        .orient("bottom");

      let yAxis = d3.svg.axis()
        .scale(y)
        .orient("left")
        .ticks(10);

      let svg = svg_elem.attr("width", width + margin.left + margin.right)
               .attr("height", height + margin.top + margin.bottom)
               .append("g")
               .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

      x.domain(data.freq.map(function(d) { return d.tier; }));
      y.domain([0, d3.max(data.freq, function(d) { return d.tier_count; })]);

      // Draw the X-axis line
      svg.append("g")
        .attr("class", "x axis")
        .attr("transform", "translate(0," + height + ")")
        .call(xAxis)
        .selectAll("text")
        .call(wrapLabels, x.rangeBand())
        //  .style("text-anchor", "end")
        //  .attr("dx", "35px") // <-- X dimension positioning
        //  .attr("dy", "10px") // <-- spacing between the y labels and the y axis
        ;

      // Draw the Y-axis line
      svg.append("g")
        .attr("class", "y axis")
        .call(yAxis.ticks(5))
        .append("text")
        .attr("class", "text-label-y")
        .attr("transform", "rotate(-90)")
        .attr("y", 6)
        .attr("dy", ".70em")
        .style("text-anchor", "end")
        //.text("Value ($)") // Label the y-axis
        ;

      // Draw the Y grid lines
      svg.append("g")
        .attr("class", "grid")
        .call(d3.svg.axis()
          .scale(y)
          .orient("left")
          .ticks(5)
          .tickSize(-width, 0, 0)
          .tickFormat("")
        );

      // Draw the bars
      svg.selectAll("bar")
        .data(data.freq)
        .enter().append("rect")
        .attr("class", function(d) {
          if (data.subj_tier == d.tier) {
            return  "subj-bar";
          }
          return "freq-bars";
        })
        .attr("x", function(d) { return x(d.tier); })
        .attr("width", x.rangeBand())
        .attr("y", function(d) { return y(d.tier_count); })
        .attr("height", function(d) { return height - y(d.tier_count); });

      let barWidth = x.rangeBand();
      let iconPosition = x(data.subj_tier) + ((barWidth - iconWidth)/2.0);

      svg.append("svg:image")
        .attr('x', iconPosition)
        .attr('y', y(data.subj_count) - iconHeight - iconMarginTop)
        .attr('width', iconWidth)
        .attr('height', iconHeight)
        .attr("xlink:href", iconUrl);
    }
  }
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/components/hvr-charts/od-hvr-bar-chart.js
 **/